module.exports = __webpack_public_path__ + "static/img/Curve.f368d647.svg";